<template>
  <div class="contents">
      <div class="sdata">
        <div class="title">多维度统计数据</div>
        <div class="write">
            实时掌握运营情况，便于商家及时调整运营策略
        </div>
        <div class="count">
            <div class="left">
                <div class="circles">
                    <div class="total"><div class="circle"><img src="./images/01.png" alt="" oncontextmenu="return false;" onselectstart="return false;"></div><div class="word">收益统计</div></div>
                    <div class="line"></div>
                </div>
                <div class="circles">
                    <div class="total"><div class="circle"><img src="./images/02.png" alt="" oncontextmenu="return false;" onselectstart="return false;"></div><div class="word">分类收入</div></div>
                    <div class="line"></div>
                </div>
                <div class="circles">
                    <div class="total"><div class="circle"><img src="./images/03.png" alt="" oncontextmenu="return false;" onselectstart="return false;"></div><div class="word">门店数据</div></div>
                    <div class="line"></div>
                </div>
            </div>
            <div class="port"><img src="./images/phone.png" alt="手机" oncontextmenu="return false;" onselectstart="return false;"></div>
            <div class="right">
                <div class="circles">
                    <div class="line"></div>
                    <div class="total"><div class="circle"><img src="./images/04.png" alt="" oncontextmenu="return false;" onselectstart="return false;"></div><div class="word">会员数据</div></div>
                </div>
                <div class="circles">  
                    <div class="line"></div>
                    <div class="total"><div class="circle"><img src="./images/05.png" alt="" oncontextmenu="return false;" onselectstart="return false;"></div><div class="word">成本数据</div></div>
                </div>
                <div class="circles">
                    <div class="line"></div>
                    <div class="total"><div class="circle"><img src="./images/06.png" alt="" oncontextmenu="return false;" onselectstart="return false;"></div><div class="word">盈利趋势</div></div>
                    
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  name:'sdata',
}
</script>

<style scoped>
.contents{
    width:100%;
    /* height: 100%; */
    height: 1397px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.sdata{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    overflow: hidden;
}
.title{
    font-family: 微软雅黑;
font-size: 50px;
line-height: 0px;
letter-spacing: 5px;
height: 50px;
line-height: 50px;
margin-top:100px;
color: #333333;
}
.write{
height: 66px;
font-family: 微软雅黑;
font-size: 24px;
letter-spacing: 1px;
color: #999999;
margin-top:51px;
text-align: center;
}
.count{
    display: flex;
    justify-content: center;
    align-items: center;
    width:1200px;
}
.port{
width: 583px;
height: 1070px;
margin-top:73px;
}
.circles{
    height: 117px;
    display: flex;
}
.circle{
    width: 80px;
	height: 80px;
	border: solid 1px #cccccc;
    border-radius: 50%;
        display: flex;
    justify-content: center;
    align-items: center
}
.circle:hover{
    border: 1px solid #198bfe;
}
.left,.right{
    height: 520px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
}
.total{
    width: 80px;
    height: 117px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
}
.word{
    font-size: 17px;
	letter-spacing: 0px;
	color: #333333;
    font-family: 微软雅黑;
}
.line{
    width:110px;
    height: 2px;
    background: #cccccc;
}
.left .circles .line{
    position: relative;
    top: 41px;
    left: 20px;
}
.right .circles .line{
    position: relative;
    top: 41px;
    right: 20px;
}
/* @media screen and (max-height:800px){
    .contents{
        height: 100vh;
    }
    .count{
        transform: scale(0.6);
    }
    .title{
        transform: scale(0.8);
        margin-top: 40px;
    }
    .write{
        transform: scale(0.8);
        margin-top:10px;
    }
    .port{
        transform: scale(0.8);
    }
} */
@media screen and (max-width:1100px){
    .port{
        transform: scale(0.8);
        margin-top: 0px;
    }
    .count{
        width: 1000px;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/software/sdata.vue